// extracted by mini-css-extract-plugin
module.exports = {"container":"MinutesField_container__Iq8M_","label":"MinutesField_label__1Kc8X","content":"MinutesField_content__2WaO_","sending":"MinutesField_sending__ACg2s"};